var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaCommentsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6687 18.0008H22C23.1063 18.0008 24 17.107 24 16.0007V4.00017C24 2.89387 23.1063 2.00009 22 2.00009H4C2.89375 2.00009 2 2.89387 2 4.00017V16.0007C2 17.107 2.89375 18.0008 4 18.0008H6C7.10625 18.0008 8 18.8946 8 20.0009V21.0009L11.4688 18.4008C11.8125 18.1383 12.2375 18.0008 12.6687 18.0008ZM22 20.0009H12.6687L7.6 23.801C7.3 24.026 6.89375 24.0635 6.55 23.8948C6.20625 23.726 6 23.3823 6 23.001V22.0009V20.0009H4C1.79375 20.0009 0 18.207 0 16.0007V4.00017C0 1.79383 1.79375 0 4 0H22C24.2062 0 26 1.79383 26 4.00017V16.0007C26 18.207 24.2062 20.0009 22 20.0009ZM20 28.0012C17.7938 28.0012 16 26.2074 16 24.001V22.0009H18V24.001C18 25.1073 18.8937 26.0011 20 26.0011H27.3312C27.7625 26.0011 28.1875 26.1386 28.5312 26.4011L32 29.0013V28.0012C32 26.8949 32.8937 26.0011 34 26.0011H36C37.1063 26.0011 38 25.1073 38 24.001V12.0005C38 10.8942 37.1063 10.0004 36 10.0004H28V8.00035H36C38.2062 8.00035 40 9.79417 40 12.0005V24.001C40 26.2074 38.2062 28.0012 36 28.0012H34V30.0013V31.0013C34 31.3826 33.7875 31.7264 33.45 31.8951C33.1125 32.0639 32.7063 32.0264 32.4 31.8014L27.3312 28.0012H20Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaCommentsAlt);
export default __webpack_public_path__ + "static/media/fa-comments-alt.0fa5519d47795e3872fc1b49ad185f6b.svg";
export { ForwardRef as ReactComponent };